import { IconButton } from '@mui/material';

import CancelIcon from '@mui/icons-material/Cancel';

import "./BaseDialog.scss";
import EscapeListener from '../Utils/EscapeListener';

export default function BaseDialog({ closeFocusRef, children, open, handleClose = ()=>{}, scroll = "body", ...props }) {

    const displayProps = {
        ...props,
        className: "BaseDialog__dialog " + props?.className ?? "",
    }

    return (
        open ? (
            <>
                <div className="BaseDialog__background"
                    onClick={handleClose}
                ></div>

                <EscapeListener enabled={open} onKeyPress={(e) => {
                    e.stopPropagation();

                    closeFocusRef?.current?.focus?.();
                    handleClose();
                }}>
                    <div 
                        {...displayProps}
                    >
                        <IconButton
                            onClick={handleClose}
                            className="BaseDialog__closeiconbutton"
                            size="large">
                            <CancelIcon style={{
                                filter: "drop-shadow( 0px 0px .5rem rgba(0, 0, 0, .4))",
                            }} />
                        </IconButton>

                        {children}
                    </div>

                </EscapeListener>
                {/* <Dialog
                    open={open}
                    onClose={handleClose}
                    scroll={scroll}
                    maxWidth="md"
                    {...props}

                    PaperProps={{
                        style: {
                            backgroundColor: "#111",
                            border: '1px solid rgba(255,255,255,0.1)',
                            borderRadius: '0px',
                        },
                    }}
                >
                    <IconButton
                        onClick={handleClose}
                        style={{
                            cursor: "pointer", 
                            display: "flex", 
                            alignItems: "center", 
                            padding: ".5rem", 
                            margin: "-.5rem",
                            position: 'absolute',
                            right: "1rem",
                            top: "1rem",
                            zIndex: 10,
                        }}
                        className="BaseDialog-CloseIconButton"
                        size="large">
                        <CancelIcon style={{
                            filter: "drop-shadow( 0px 0px .5rem rgba(0, 0, 0, .4))",
                        }} />
                    </IconButton>

                    {children}
                </Dialog> */}
            </>
        ):""
    );
}
